module.exports = __webpack_public_path__ + "static/img/banner_zoology.4310fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/banner_zoology.png
// module id = iriJ
// module chunks = 15